export default function ArrowSharpMinimal({
  className,
}: {
  className?: string
}) {
  return (
    <svg width="100%" height="100%" className={className} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1374 5.82591L8.9266 11.9277L1.71582 5.82591L3.01953 4.28608L8.9266 9.28398L14.8337 4.28608L16.1374 5.82591Z"/>
    </svg>
  )
}
